import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import ToolsService from "@/services/ToolsService";
import { useAuthStore } from "@/store/auth.store";
import { useTheme } from "vuetify/lib/framework.mjs";

export default class SettingsViewModel {
  public userinfo = ref();

  public authStore = useAuthStore();
  private theme = useTheme();

  private router = useRouter();
  private toolsService: ToolsService;

  public isDarkMode = computed({
    get: () => this.theme.global.name.value === "dark",
    set: (value: string) => {
      //console.log(value);
      const newTheme =
        this.theme.global.name.value === "dark" ? "light" : "dark";
      this.theme.global.name.value = newTheme;

      // Guardar el tema seleccionado en localStorage
      localStorage.setItem("theme", newTheme);
    },
  });

  public session = computed({
    get: () => this.authStore.isSessionExpired ?? false,
    set: (value: boolean) => {
      this.authStore.expireSession({
        sessionExpired: value,
      });
    },
  });

  constructor() {
    this.toolsService = new ToolsService();
    this.initializeTheme();
    this.loadUserInfo();
  }

  private initializeTheme(): void {
    // Cargar el tema desde localStorage al iniciar
    const systemPrefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    const defaultTheme = systemPrefersDark ? "dark" : "light";

    // Crear una referencia para almacenar el tema
    const savedTheme = localStorage.getItem("theme") || defaultTheme;

    if (savedTheme) {
      this.theme.global.name.value = savedTheme;
    }
  }

  public isLoading = ref(true);

  private async loadUserInfo(): Promise<void> {
    this.isLoading.value = true;
    try {
      const data = await this.authStore.getUserData;
      this.userinfo.value = data;
      this.isLoading.value = false;
    } catch (error) {
      console.error("Error loading user info", error);
      this.isLoading.value = false;
    }
  }
  public getUserInitials(): string {
    return this.userinfo.value?.esnatural
      ? this.toolsService.inicial(this.userinfo.value?.nom ?? "")
      : this.toolsService.inicial(this.userinfo.value?.razonsocial ?? "");
  }

  public getFormattedName(): string {
    if (this.userinfo.value?.esnatural) {
      return this.toolsService.capitalize(this.userinfo.value?.nom ?? "");
    }
    return this.toolsService.capitalize(this.userinfo.value?.razonsocial ?? "");
  }

  public getHiddenEmail(): string {
    return this.toolsService.hideEmailCharacters(
      this.toolsService.lowercase(this.userinfo.value?.email ?? "")
    );
  }

  public getHiddenPhone(): string {
    return this.userinfo.value?.telfijo
      ? this.toolsService.hideWords(this.userinfo.value?.telfijo ?? "")
      : this.toolsService.hideWords(this.userinfo.value?.telmovil ?? "");
  }

  /*   public changeSession = (): void => {
    this.authStore.expireSession({
      sessionExpired: !this.authStore.isSessionExpired,
    });
  }; */

  public goToWsp(): void {
    const phoneNumber = "937311462";
    window.location.href = `https://wa.me/+51${phoneNumber}`;
  }

  public logout(): void {
    console.log("Logging out...");
    this.router.push("/login");
  }
}
